import * as React from 'react';

function SvgCheckmark(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 20 20" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx={10} cy={10} fill="currentColor" r={10} />
        <path
          d="M16.197 5.68a1.05 1.05 0 00-1.44.025l-6.453 6.51-2.207-2.206a.953.953 0 00-1.384.036l-.033.036a1.039 1.039 0 00.03 1.432l2.883 2.797a1.02 1.02 0 001.42-.014l7.252-7.2a.95.95 0 00-.032-1.383l-.036-.033z"
          fill={props.fill ? props.fill : '#00182E'}
        />
      </g>
    </svg>
  );
}

export default SvgCheckmark;
